import { render } from "./CompanyDetails.vue?vue&type=template&id=17b44c74&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=17b44c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b44c74"]])

export default __exports__